import { useState, useEffect } from 'react';
import { API_ENDPOINTS, fetchFromApi } from '../config/api';

export const useTwitchStatus = () => {
  const [isLive, setIsLive] = useState(false);
  const [streamData, setStreamData] = useState(null);

  useEffect(() => {
    const checkTwitchStatus = async () => {
      try {
        const liveStreams = await fetchFromApi(API_ENDPOINTS.checkTwitchStreams);
        if (liveStreams && liveStreams.length > 0) {
          setIsLive(true);
          setStreamData(liveStreams[0]); // Use the first live stream
        } else {
          setIsLive(false);
          setStreamData(null);
        }
      } catch (error) {
        console.error('Error checking Twitch status:', error);
        setIsLive(false);
        setStreamData(null);
      }
    };

    // Check immediately
    checkTwitchStatus();

    // Then check every minute
    const interval = setInterval(checkTwitchStatus, 60000);

    return () => clearInterval(interval);
  }, []);

  return { isLive, streamData };
};
